<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add URL</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="clientSelected" (change)="onClientChange($event.target.selectedIndex)">
        <option *ngFor="let client of clients" [value]="client.id">{{client.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="fieldSelected"
              (change)="onFieldChange($event.target.selectedIndex)">
        <option *ngFor="let field of fields" [value]="field.id">{{field.name}}</option>
      </select>
    </div>
    <div class="form-group ticket-menu">
      <mat-checkbox class ="font-13" *ngFor="let fieldValue of fieldValues" value="{{fieldValue.id}}" [(ngModel)]="fieldValue.checked">{{fieldValue.name}}</mat-checkbox>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>